import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EOfferType, IOfferTypeState } from 'shared/types/wantType';

const initialState: IOfferTypeState = { value: EOfferType.Apartment };

/* istanbul ignore next */
const offerTypeSlice = createSlice({
  initialState,
  name: 'offerType',
  reducers: {
    setOfferType: (state, action: PayloadAction<EOfferType>) => {
      state.value = action.payload;
    },
  },
});

export const {
  reducer: offerTypeReducer,
  actions: { setOfferType },
} = offerTypeSlice;
